<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button class="skip-walkthrough-button" fill="clear" (click)="skipWalkthrough()">{{ 'APP.BUTTON.Skip' | translate }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content scrollbar="true">
  <swiper [pagination]="true" class="walkthrough-slides" (swiper)="setSwiperInstance($event)" (init)="swiperInit()" (slideChangeTransitionStart)="slideWillChange()">
    <ng-template swiperSlide>
      <ion-row class="slide-inner-row first-slide illustration-and-decoration-slide">
        <ion-col class="illustration-col pb-0">
          <app-aspect-ratio [ratio]="{w:599, h:618}"> 
            <app-image-shell class="illustration-image" animation="spinner" [src]="'./assets/images/walkthrough/' + versionPath + 'walkthrough-illustration-1.png'" [alt]="'walkthrough'"></app-image-shell>
          </app-aspect-ratio>
        </ion-col>
        <ion-col class="decoration-col">
          <svg class="vector-decoration" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" height="100px" width="100%" viewBox="0 0 90 20" style="enable-background:new 0 0 90 20;" xml:space="preserve" preserveAspectRatio="none">
            <path d="M0 0 V5 H5 C25 5 25 20 45 20 S65 5 85 5 H90 V0 Z"/>
          </svg>
        </ion-col>
        <ion-col class="info-col">
          <div class="info-wrapper">
            <h3 class="info-title">{{ 'APP.WALKTHROUGH.slide-1-title' | translate }}</h3>
            <p class="info-paragraph" [innerHTML]="'APP.WALKTHROUGH.slide-1-description' | translate"></p>
          </div>
        </ion-col>
      </ion-row>
    </ng-template>
    <ng-template swiperSlide>
      <ion-row class="second-slide illustration-and-decoration-slide slide-inner-row">
        <ion-col class="illustration-col">
          <app-aspect-ratio [ratio]="{w:915, h:849}">
            <app-image-shell class="illustration-image" animation="spinner" [src]="'./assets/images/walkthrough/' + versionPath + 'walkthrough-illustration-2.svg'" [alt]="'walkthrough'"></app-image-shell>
          </app-aspect-ratio>
        </ion-col>
        <ion-col class="decoration-col">
          <svg class="vector-decoration" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" height="100px" width="100%" viewBox="0 0 64 24" style="enable-background:new 0 0 64 24;" xml:space="preserve" preserveAspectRatio="none">
            <path d="M0 0 L64 0 L64 24 Q56 24 48 16 Q34 0 22 10 Q10 22 0 8 Z"/>
          </svg>
        </ion-col>
        <ion-col class="info-col">
          <div class="info-wrapper">
            <h3 class="info-title">{{ 'APP.WALKTHROUGH.slide-2-title' | translate }}</h3>
            <p class="info-paragraph" [innerHTML]="'APP.WALKTHROUGH.slide-2-description' | translate"></p>
          </div>
        </ion-col>
      </ion-row>
    </ng-template>
    <ng-template swiperSlide>
      <ion-row class="third-slide illustration-and-decoration-slide slide-inner-row">
        <ion-col class="illustration-col pb-0">
          <app-aspect-ratio [ratio]="{w:350, h:350}">
            <app-image-shell class="illustration-image" animation="spinner" [src]="'./assets/images/walkthrough/' + versionPath + 'walkthrough-illustration-3.png'" [alt]="'walkthrough'"></app-image-shell>
          </app-aspect-ratio>
        </ion-col>
        <ion-col class="decoration-col">
          <svg class="vector-decoration" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" height="100px" width="100%" viewBox="0 0 64 24" style="enable-background:new 0 0 64 24;" xml:space="preserve" preserveAspectRatio="none">
            <path d="M0 0 L64 0 L64 24 Q56 24 48 16 Q34 0 22 10 Q10 22 0 8 Z"/>
          </svg>
        </ion-col>
        <ion-col class="info-col">
          <div class="info-wrapper">
            <h3 class="info-title">{{ 'APP.WALKTHROUGH.slide-3-title' | translate }}</h3>
            <p class="info-paragraph" [innerHTML]="'APP.WALKTHROUGH.slide-3-description' | translate"></p>
          </div>
        </ion-col>
      </ion-row>
    </ng-template>
    <ng-template swiperSlide>
      <ion-row class="fourth-slide illustration-and-decoration-slide slide-inner-row">
        <ion-col class="illustration-col pb-0">
          <app-aspect-ratio [ratio]="{w:600, h:600}">
            <app-image-shell class="illustration-image" animation="spinner" [src]="'./assets/images/walkthrough/' + versionPath + 'walkthrough-illustration-4.png'" [alt]="'walkthrough'"></app-image-shell>
          </app-aspect-ratio>
        </ion-col>
        <ion-col class="decoration-col">
          <svg class="vector-decoration" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" height="100px" width="100%" viewBox="0 0 64 24" style="enable-background:new 0 0 64 24;" xml:space="preserve" preserveAspectRatio="none">
            <path d="M0 0 L64 0 L64 24 Q56 24 48 16 Q34 0 22 10 Q10 22 0 8 Z"/>
          </svg>
        </ion-col>
        <ion-col class="info-col">
          <div class="info-wrapper">
            <h3 class="info-title">{{ 'APP.WALKTHROUGH.slide-4-title' | translate }}</h3>
            <p class="info-paragraph" [innerHTML]="'APP.WALKTHROUGH.slide-4-description' | translate"></p>
          </div>
        </ion-col>
      </ion-row>
    </ng-template>
    <ng-template swiperSlide>
      <ion-row class="fifth-slide illustration-and-decoration-slide slide-inner-row">
        <ion-col class="illustration-col">
          <app-aspect-ratio [ratio]="{w:918, h:703}">
            <app-image-shell class="illustration-image" animation="spinner" [src]="'./assets/images/walkthrough/' + versionPath + 'walkthrough-illustration-5.svg'" [alt]="'walkthrough'"></app-image-shell>
          </app-aspect-ratio>
        </ion-col>
        <ion-col class="decoration-col">
          <svg class="vector-decoration" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" height="100px" width="100%" viewBox="0 0 64 14" style="enable-background:new 0 0 64 24;" xml:space="preserve" preserveAspectRatio="none">
            <path d="M0 0 V5 H5 C19 5 25 14 32 14 S45 5 59 5 H64 V0 Z"/>
          </svg>
        </ion-col>
        <ion-col class="info-col">
          <div class="info-wrapper">
            <h3 class="info-title">{{ 'APP.WALKTHROUGH.slide-5-title' | translate }}</h3>
            <p class="info-paragraph" [innerHTML]="'APP.WALKTHROUGH.slide-5-description' | translate"></p>
          </div>
        </ion-col>
      </ion-row>
    </ng-template>
    <ng-template swiperSlide>
      <ion-row class="last-slide illustration-and-decoration-slide slide-inner-row">
        <ion-col class="illustration-col">
          <app-aspect-ratio [ratio]="{w:325, h:325}">
            <app-image-shell class="illustration-image" animation="spinner" [src]="'./assets/images/walkthrough/' + versionPath + 'walkthrough-illustration-6.png'" [alt]="'walkthrough'"></app-image-shell>
          </app-aspect-ratio>
        </ion-col>
        <ion-col class="decoration-col">
          <svg class="vector-decoration" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" height="100px" width="100%" viewBox="0 0 64 18" style="enable-background:new 0 0 64 24;" xml:space="preserve" preserveAspectRatio="none">
            <path d="M0 0 L64 0 L64 10 Q56 24 46 12 Q34 0 26 8 Q10 22 0 8 Z"/>
          </svg>
        </ion-col>
        <ion-col class="info-col">
          <ion-row class="info-outer">
            <ion-col>
              <div class="info-wrapper">
                <h3 class="info-title">{{ 'APP.WALKTHROUGH.slide-6-title' | translate }}</h3>
                <p class="info-paragraph" [innerHTML]="'APP.WALKTHROUGH.slide-6-description' | translate"></p>
              </div>
            </ion-col>
            <ion-col class="call-to-actions-wrapper">
              <ion-button class="get-started-button" expand="block" [routerLink]="['/app/dashboard']">{{ 'APP.BUTTON.GetStarted' | translate }}</ion-button>
              <!-- <ion-row class="alt-call-to-action-row">
                <span class="cta-leading-text">Already have an account?</span>
                <ion-button class="login-button" fill="clear" [routerLink]="['/auth/login']">
                  Login here
                </ion-button>
              </ion-row> -->
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
    </ng-template>
  </swiper>
</ion-content>
